/**
 * Stima lo spazio di archiviazione utilizzato e disponibile.
 * Restituisce l'uso e la quota in megabyte.
 */
export async function getStorageEstimate(): Promise<{ usage: number, quota: number } | null> {
    if (navigator.storage && navigator.storage.estimate) {
      const estimate = await navigator.storage.estimate();
      return {
        usage: estimate.usage ? estimate.usage / (1024 * 1024) : 0,
        quota: estimate.quota ? estimate.quota / (1024 * 1024) : 0,
      };
    }
    return null;
  }
  
  /**
   * Controlla se c'è abbastanza spazio per memorizzare un file di una data dimensione.
   * @param requiredBytes - La dimensione in byte del file da salvare.
   * @returns true se c'è spazio sufficiente, altrimenti false.
   */
  export async function canStore(requiredBytes: number): Promise<boolean> {
    if (!navigator.storage || !navigator.storage.estimate) {
      // Se l'API non è supportata, si assume che ci sia spazio per evitare di bloccare il salvataggio.
      return true;
    }
    try {
      const estimate = await navigator.storage.estimate();
      const availableSpace = (estimate.quota ?? 0) - (estimate.usage ?? 0);
      // Lascia un margine di sicurezza (es. 10MB)
      const safetyMargin = 10 * 1024 * 1024; 
      return availableSpace - safetyMargin > requiredBytes;
    } catch (error) {
      console.warn('Could not estimate storage:', error);
      return true; // Fallback in caso di errore
    }
  }
  